import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSiteConfig } from "../../context/SiteConfigContext";
import { useCart } from "../../context/CartContext";
import { Swiper, SwiperSlide, Autoplay, Pagination } from "../homepage/Shared/CustomSwiper";
import { Heart, ShoppingBag } from "lucide-react";
import { showError } from "../../utils/toastUtils";
import Auth from "../../utils/AuthUtils";
import wishlistAPI from "../../api/wishlistApi";

function Card({ item }) {
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const { config } = useSiteConfig();

  // Logic same as yours
  const initialPrice = item?.productType === "Variant" ? (item?.variants?.[0]?.price ?? 0) : (item?.price ?? 0);
  const initialMrp = item?.productType === "Variant" ? (item?.variants?.[0]?.mrp ?? 0) : (item?.mrp ?? 0);
  const initialDiscount = item?.productType === "Variant" ? (item?.variants?.[0]?.discount ?? 0) : (item?.discount ?? 0);
  const initialStock = item?.productType === "Variant" ? (item?.variants?.[0]?.stock ?? 0) : (item?.stock ?? 0);

  const [activePrice, setActivePrice] = useState(initialPrice);
  const [activeMrp, setActiveMrp] = useState(initialMrp);
  const [activeDiscount, setActiveDiscount] = useState(initialDiscount);
  const [activeStock, setActiveStock] = useState(initialStock);
  const [activeVariantId] = useState(item?.productType === "Variant" && item?.variants?.length ? item?.variants[0]._id : null);
  const [isWishlisted, setIsWishlisted] = useState(item.isWishlisted || false);

  const galleryImages = [item?.thumbnail, ...(item?.gallery || [])].filter(Boolean);
  const hasDiscount = activeDiscount > 0 && activeMrp > activePrice;
  const isOutOfStock = activeStock <= 0;

  const handleAddToCart = (e) => {
    try {
      addToCart(item?._id, 1, activeVariantId || "");
    } catch (err) { console.error(err); }
  };

  const handleWishlistToggle = async (e) => {
    e.preventDefault();
    if (!Auth.getToken()) return showError("Please login to wishlist");
    try {
      const res = await wishlistAPI.addProduct({ productId: item?._id });
      if (res.code === 200) setIsWishlisted(!isWishlisted);
    } catch (err) { showError("Failed to update wishlist"); }
  };

  return (
    <div className="product-card">
      {/* 1. IMAGE SECTION */}
      <div className="product-image-wrapper">
        <button className={`wishlist-btn ${isWishlisted ? "active" : ""}`} onClick={handleWishlistToggle}>
          <Heart size={18} fill={isWishlisted ? "currentColor" : "none"} />
        </button>

        {hasDiscount && <div className="discount-badge-top">{Math.round(activeDiscount)}% OFF</div>}

        <Link to={`/shop/${item?.slug}`} className="product-img-wrapper">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={0}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 4000 }}
            className="product-swiper"
          >
            {galleryImages.map((img, index) => (
              <SwiperSlide key={index}>
                <img src={img} alt={item?.title} loading="lazy" className="product-image" />
              </SwiperSlide>
            ))}
          </Swiper>
        </Link>
      </div>

      {/* 2. DETAILS SECTION */}
      <div className="product-info-content">
        <Link to={`/shop/${item?.slug}`} className="text-decoration-none text-dark">
          <h6 className="product-title">{item?.title}</h6>
          {/* Description dikhane ke liye */}
          <p className="product-short-desc">
            {item?.shortDescription || "Pure and premium quality selected especially for you."}
          </p>
        </Link>

        <div className="price-container">
          <span className="active-price">₹{activePrice}</span>
          {hasDiscount && <span className="old-price">₹{activeMrp}</span>}
        </div>

        {/* 3. BUTTON SECTION - Locked at Bottom */}
        <div className="card-action-area">
          {isOutOfStock ? (
            <button className="out-of-stock-btn" disabled>OUT OF STOCK</button>
          ) : (
            <button 
              className="add-to-cart-permanent"
              onClick={handleAddToCart}
              data-bs-toggle="offcanvas"
              data-bs-target="#shoppingCartCanvas"
            >
              <ShoppingBag size={18} className="me-2" />
              ADD TO BAG
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Card;